<template>
  <div ref="animation">
    <lottie :options="options" v-on:animCreated="handleAnimation" />
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "@/assets/animations/play.json";

export default {
  components: {
    Lottie,
  },
  data() {
    return {
      options: {
        animationData: animationData.default,
        loop: false,
        autoplay: false,
      },
    };
  },
  methods: {
    handleAnimation(animation) {
      const duration = animation.getDuration(true);
      animation.goToAndStop(duration - 1, true);

      this.$refs["animation"].addEventListener("mouseenter", () => {
        animation.goToAndPlay(0, true);
      });
    },
  },
};
</script>
